<!-- 历史净值 -->
<template>
  <div class="box">
    <common-list
      :header-list="listHeader"
      :data-source="getData()"
      :more-text="'至APP中查看更多 >>'"
      :more-link="moreLink"
      @clickMore="clickMore"
      ref="list"
    >
      <template slot="list-item" slot-scope="{ item }">
        <div class="item">
          <p style="text-align: left" class="date">{{ item.row1 }}</p>
          <!-- 货币第二列有个红色* -->
          <div class="row2">
            <p style="text-align: center" class="dwjz">{{ item.row2 }}</p>
            <p
              class="red-tip"
              v-if="isFloatCurrency && item.NAVTYPE === '0.0'"
              >*</p
            >
          </div>
          <p
            v-if="!isFloatCurrency"
            style="text-align: center"
            class="ljjz"
            >{{ item.row3 }}</p
          >
          <p
            :style="{
              color: highEndFundColor(item.row4),
              textAlign: isShowFundSize ? 'center' : 'right',
            }"
            class="rise"
            >{{ item.row4 === "--" ? "--" : item.row4 + "%" }}</p
          >
          <p v-if="isShowFundSize" class="size">{{ item.fundSize }}</p>
        </div>
      </template>
      <template slot="list-bottom-extra" v-if="isShowFundSize">
        <p class="risk-text">数据来源：基金管理人/托管人。</p>
      </template>
    </common-list>
  </div>
</template>

<script>
import tool from '@/utils/tool';
import isEmpty from '@fund/basic-lib/dist/lib/lang/isEmpty';
import { numeral } from '@fund/basic-lib/dist/lib/numeral';
import dayjs from 'dayjs';

import CommonList from './CommonList.vue';

export default {
  props: {
    fundCode: String, // 基金代码
    elementData: Object, // 基金数据
    mergeData: Object,
    tradeData: Array,
  },

  components: {
    CommonList,
  },

  data() {
    return {
      // 分页索引
      pageIndex: 1,
      // 接口数据
      dataList: [],

      // 排序
      sort: 'desc',

      moreText: '查看更多',
    };
  },

  computed: {
    listHeader() {
      // 获取类型 判断是否是浮动货币
      const { isFloatCurrency } = this.elementData;
      // 配置列表头
      const list = isFloatCurrency
        ? [
          {
            key: 'date',
            name: '日期',
            style: {
              flex: 1,
              textAlign: 'left',
              justifyContent: 'flex-start',
            },
          },
          {
            key: 'netAssetValue',
            name: '万元收益',
            style: {
              flex: 1,
              textAlign: 'center',
              justifyContent: 'center',
            },
            showTip: true,
            showModal: () => {
              const modal = {
                content: '*代表多天万元收益合并',
                confirmText: '知道了',
                confirmColor: '#ff4400',
                showCancel: false,
              };
              multi.$feedback.showModal(modal);
            },
          },
          {
            key: 'rise',
            name: '七日年化',
            style: {
              flex: 1,
              textAlign: this.isShowFundSize ? 'center' : 'right',
              justifyContent: this.isShowFundSize ? 'center' : 'flex-end',
            },
          },
        ]
        : [
          {
            key: 'date',
            name: '日期',
            style: {
              flex: 1,
              textAlign: 'left',
              justifyContent: 'flex-start',
            },
          },
          {
            key: 'netAssetValue',
            name: '单位净值',
            style: {
              flex: 1,
              textAlign: 'center',
              justifyContent: 'center',
            },
          },
          {
            key: 'accumulatedNet',
            name: '累计净值',
            style: {
              flex: 1,
              textAlign: 'center',
              justifyContent: 'center',
            },
          },
          {
            key: 'rise',
            name: '日涨幅',
            style: {
              flex: 1,
              textAlign: this.isShowFundSize ? 'center' : 'right',
              justifyContent: this.isShowFundSize ? 'center' : 'flex-end',
            },
            showTip: true,
            showModal: () => {
              const modal = {
                title: '日增长率为空原因',
                content: '1、非工作日净值不参与日增长率计算（灰色数据行）。\n2、上一交易日净值未披露，日增长率无法计算。',
                confirmText: '知道了',
                confirmColor: '#ff4400',
                showCancel: false,
              };
              multi.$feedback.showModal(modal);
            },
          },
        ];
      if (this.isShowFundSize) {
        list.push({
          key: 'fundSize',
          name: '历史规模',
          style: {
            flex: 1.23,
            textAlign: 'right',
            justifyContent: 'flex-end',
          },
          showTip: false,
        });
      }
      return list;
    },

    isFloatCurrency() {
      return this.elementData.isFloatCurrency;
    },

    isShowFundSize() {
      return this.mergeData?.isShowFundSize ?? false;
    },
    // 是否持仓 前后端都有
    isHold() {
      const { tradeData } = this;
      if (tradeData?.length) {
        return tradeData?.[0]?.isHold || tradeData?.[1]?.isHold;
      }
      return false;
    },
    moreLink() {
      return `fund://mp.1234567.com.cn/weex/b34ccfc4ed9a4af4a4880fee485cf417/pages/gdlcHistoryValue/index?fundCode=${this.fundCode}&fundName=${this.elementData?.fundName}&isCurrency=false&isHold=${this.isHold}&isShowFundSize=${this.isShowFundSize}`;
    },
  },

  methods: {
    // 点击提示
    showTip() {
      const { isFloatCurrency } = this;
      const modal = {
        title: isFloatCurrency ? '' : '日增长率为空原因',
        content: isFloatCurrency
          ? '*代表多天万元收益合并'
          : '1、非工作日净值不参与日增长率计算（灰色数据行）。\n2、上一交易日净值未披露，日增长率无法计算。',
        confirmText: '知道了',
        confirmColor: '#ff4400',
        showCancel: false,
      };
      multi.$feedback.showModal(modal);
    },

    // 获取数据
    async getData() {
      const result = await this.$http.useRequests('FundComApi.getHighEndDiagramPageSort', this.fundCode);
      if (result?.success) {
        return this.handleListData(result.data || []);
      }
      return [];
    },

    handleListData(dataList) {
      const { isFloatCurrency } = this.elementData || {};
      const listItems = [];
      // 配置列表内容数据
      dataList.forEach((element) => {
        const temp = {};
        temp.row1 = this.handleDate(element.PDATE);
        temp.row2 = numeral(isFloatCurrency ? element.MUI : element.NAV).format(
          '0.0000',
        );
        // 浮动货币没有这一列
        if (!isFloatCurrency) {
          temp.row3 = numeral(element.ACCNAV).format('0.0000');
        }
        temp.row4 = isFloatCurrency
          ? numeral(element.SYI).format('0.0000')
          : numeral(element.NAVCHGRT100).format('0.00');
        temp.fundSize = isEmpty(element?.FUNDSIZE)
          ? '--'
          : `${numeral(element.FUNDSIZE / 10000).format('0')}万`;
        temp.NAVTYPE = element.NAVTYPE;
        listItems.push(temp);
      });
      return listItems;
    },

    // 查看更多
    clickMore() {
      this.$wxSendTrack('wxgdpzy.sy.gdlsjz.click', 'Click', { infoCode: this.fundCode, infoCodeType: 5 });
    },

    // 颜色
    highEndFundColor(value) {
      return tool.highEndFundColor(value);
    },

    // 时间格式化 当年不保留年 非当年保留年
    handleDate(value) {
      if (!value || value === '--') {
        return '--';
      }
      const arr = value.split('-');
      const date = new Date();
      const nowYear = date.getFullYear();
      // 正则匹配成MM-dd格式
      // return nowYear === arr[0] - 0 ? formatDate(new Date(value), 'MM-dd') : value;
      return nowYear === arr[0] - 0
        ? value.replace(/(\d{4})-(\d{2})-(\d{2})/, '$2-$3')
        : dayjs(value).format('YY-MM-DD');
    },
  },
};
</script>

<style scoped>
.risk-text {
  font-family: PingFangSC-Regular;
  font-size: 24px;
  color: #999999;
  letter-spacing: 1px;
  margin: 16px 0 0 0;
}
.box {
  border-radius: 16px;
  background-color: #ffffff;
  padding: 0 24px;
}

.item {
  display: flex;
  padding-top: 16px;
  padding-bottom: 16px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.date {
  flex: 1;
  font-family: DINAlternate-Bold;
  font-size: 30px;
  color: #000000;
}

.rise {
  font-family: DINAlternate-Bold;
  flex: 1;
  font-size: 30px;
  color: #000000;
}

.size {
  font-family: DINAlternate-Bold;
  flex: 1.23;
  font-size: 30px;
  color: #000000;
  text-align: right;
}

.row2 {
  flex: 1;
  flex-direction: row;
  text-align: center;
  justify-content: center;
}

.dwjz {
  flex: 1;
  font-family: DINAlternate-Bold;
  font-size: 30px;
  color: #000000;
}

.red-tip {
  color: #ff4400;
  font-size: 30px;
}

.ljjz {
  flex: 1;
  font-family: DINAlternate-Bold;
  font-size: 30px;
  color: #000000;
}
</style>
